<template>
  <div class="overflow-x-hidden overflow-y-scroll safari-scroll w-full bg-gray-900" style='min-height: 90vh; max-height: 90vh'>

      <div class="w-full bg-gray-800 bg-no-repeat" style="
                  background-blend-mode: multiply;
                  background-position: center center;
                  background-size: contain;
                  background-image: url('/img/PBC_Ninja.svg');
                  ">
        <div class="p-10 py-3 pb-6 flex flex-col flex-wrap justify-center content-center">
          <div class="z-60 auth-content-rotate">
            <h1 class="text-white font-bold text-2xl">How do you</h1>
            <h1 class="text-white text-xl -mt-3">want to start your</h1>
            <h2 class="text-blue-300 font-bold text-2xl -mt-2">Post</h2>
          </div>
        </div>
      </div>

      <div>
        <div class="flex-none mx-0 md:mx-64 flex justify-center template-add-type-buttons pt-2">
          <pbc-toggle-button v-model='isTemplate' class="template-add-type-icon" mode='outline'>
            <file-document-outline :size='iconSize'/>
              <span class="type-label">Template</span>
          </pbc-toggle-button>
          <pbc-toggle-button v-model='isBlank' class="template-add-type-icon" mode='outline'>
            <file :size='iconSize'/> <span class="type-label">Blank</span>
          </pbc-toggle-button>
          <image-uploader game-id='uploader'
                          @select='onSelectImage'
                          class='template-add-image-uploader'
                          :single-upload='true'
                          :already-uploaded='[]'
                          >
            <template #default='{waitingProcess, waitingUpload}'>
              <pbc-toggle-button v-model='isUpload' class="template-add-type-icon" mode='outline'>
                <upload :size='iconSize'/>
                <span class="type-label">Upload</span>
              </pbc-toggle-button>
            </template>
          </image-uploader>


        </div>
        <div class="flex-none mx-0 md:mx-64 flex justify-center template-add-type-buttons">
          <pbc-toggle-button v-model='isImage' class="template-add-type-icon" mode='outline'>
            <image-icon :size='iconSize'/>
            <span class="type-label">Images</span>
          </pbc-toggle-button>
          <pbc-toggle-button v-model='isSticker' class="template-add-type-icon" mode='outline'>
            <sticker-emoji :size='iconSize'/>
            <span class="type-label">Stickers</span>
          </pbc-toggle-button>
          <pbc-toggle-button v-model='isVideo' class="template-add-type-icon" mode='outline'>
            <movie :size='iconSize'/>
            <span class="type-label">Videos</span>
          </pbc-toggle-button>

          <apollo-query :query='getPostDraftsQuery' :skip='isServer' client-id='localClient' :tag='""'>
            <template v-slot="{ result: { loading, error, data } }">
              <pbc-toggle-button v-model='isDraft' class="template-add-type-icon" mode='outline' :disabled='((data||{}).postDrafts||[]).length === 0'>
                <file-document-outline :size='iconSize'/>
                <div class="flex flex-row">
                  <span class="type-label">Drafts</span>
                  <span v-if='data && data.postDrafts && data.postDrafts.length' class="bg-orange-400 text-black ml-1 px-1 rounded">{{((data||{}).postDrafts||[]).length}}</span>
                </div>

              </pbc-toggle-button>
            </template>
          </apollo-query>


        </div>


        <select-template v-if='isTemplate' class='overflow-x-hidden bg-gray-900' style='min-height:80%' />

        <view-tenor-videos v-if='isVideo'
                            @select-animation='onSelectAnimation'
                            class="grow mx-1"
                            />

        <view-gfycat-stickers v-if='isSticker'
                              @select='onSelectSticker'
                              class="grow mx-1"  />

        <instant-select-pack v-if='isImage'
                              :grid='true'
                              class="grow bg-gray-900 mx-1"
                              @select-uploaded-image='onSelectImage'
                              @select-image='onSelectPack'
                              @select-toy='onSelectToy'

                          />

        <view-drafts v-if='isDraft'
                    @change-draft='onChangeDraft'
                    @create-new='onCreateBlank'
                    />

        <div v-if='isBlank' class="grid grid-cols-2 gap-4 px-3 pt-8">
          <button class="px-3 rounded my-1 text-center flex flex-col justify-end h-32"
                @click='onCreateBlank("12x16")'
                style='background-color: #4A5568'>
            <crop-portrait class="text-gray-400 mx-auto" :size='64' />
            <div class="create-type-text">
                Portrait
            </div>
          </button>
          <button class="px-3 rounded my-1 text-center flex flex-col justify-end h-32"
                @click='onCreateBlank("16x12")'
                style='background-color: #4A5568'>
            <crop-landscape class="text-gray-400 mx-auto" :size='64' />
            <div class="create-type-text">
                <span>Landscape</span>
            </div>
          </button>
        </div>

      </div>

  </div>

</template>
<script>
import { getPostDraftsQuery } from '@/gql/Queries.js';
const ImageUploader = () => import(/* webpackChunkName: "edit" */ '@ui/molecules/ImageUploader.vue');
import InstantSelectPack from '@ui/molecules/InstantSelectPack.vue';
import SelectTemplate from '@ui/molecules/SelectTemplate.vue';
import ViewDrafts from '@ui/molecules/ViewDrafts.vue';
import Movie from '@icons/Movie.vue';
import Image from '@icons/Image.vue';
import StickerEmoji from '@icons/StickerEmoji.vue';
import Upload from '@icons/Upload.vue';
import FileDocumentOutline from '@icons/FileDocumentOutline.vue';
import File from '@icons/File.vue';
import ViewTenorVideos from '@ui/molecules/ViewTenorVideos.vue';
import ViewGfycatStickers from '@ui/molecules/ViewGfycatStickers.vue';
import CropPortrait from '@icons/CropPortrait.vue';
import CropLandscape from '@icons/CropLandscape.vue';


export default {
  inject: ['api'],
  components:{
    SelectTemplate,
    ViewDrafts,
    InstantSelectPack,
    Movie,
    StickerEmoji,
    Upload,
    FileDocumentOutline,
    File,
    ImageIcon: Image,
    ViewTenorVideos,
    ViewGfycatStickers,
    ImageUploader,
    CropPortrait,
    CropLandscape

  },
  data() {
    return {
      getPostDraftsQuery,
      from:0,
      size:100,
      image:'',
      iconSize:42
    }
  },
  mounted() {
    this.$ana.track({
      eventCategory:'ui',
      eventAction:'openCreateDialog'
    });
  },
  beforeDestroy() {
    this.$ana.track({
      eventCategory:'ui',
      eventAction:'closeCreateDialog'
    });
  },
  methods:{
    onSelectToy({layer,toysheet,toy,position}) {
      console.log('select toy', layer, toysheet, toy, position);
    },
    onCreateBlank(aspect) {
      console.log('create blank yes');
      if (!aspect) {
        this.$router.push({
          name:'start',
          params:{
            parentId: 'root',
            type: 'post',
          },
          query:{
            prompt: undefined
          }
        });
      } else {
        this.$router.push({
          name:'start',
          params:{
            parentId: 'root',
            type: 'post',
            __autoRemixData: {aspect}
          },
          query:{
            prompt: undefined
          }
        });

        this.$ana.track({
          eventCategory:'create',
          eventAction:'blank-'+aspect
        });
      }
    },

    onSelectSticker(animation) {
      const layer = {
        id:"toy",
        name:"Toy",
        zindex:2,
        projection:"orthogonal",
        direction:"rightdown"
      }
      this.onPushAnimation(animation, layer);
      this.$ana.track({
        eventCategory:'create',
        eventAction:'sticker'
      });
    },
    onSelectAnimation(animation) {
      const layer = {
        id:"default",
        zindex:1,
        projection:"orthogonal",
        direction:"rightdown"
      }
      this.onPushAnimation(animation, layer, 'contain');
      this.$ana.track({
        eventCategory:'create',
        eventAction:'video'
      });
    },
    onPushAnimation(animation, layer, scale) {
      const autoRemixData = {
        animation,
        layer,
        scale
      }
      console.log('auto remix', autoRemixData);
      this.$router.replace({
        name:'start',
        params:{
          parentId:'root',
          type:'post',
          __autoRemixData: autoRemixData,
        }
      });
    },
    onSelectUploadedImage(data) {
      console.log('on select uploaded image', data);
      this.$emit('select-uploaded-image', data);
    },
    onSelectPack({layer,toysheet,image,spritesheet,position}) {
      console.log('select pack!!!!!!!')
      const autoRemixData = {
        layer,
        toysheet,
        image,
        spritesheet,
        scale:'contain'
      }
      console.log('auto remix', autoRemixData);
      this.$router.replace({
        name:'start',
        params:{
          parentId:'root',
          type:'post',
          __autoRemixData: autoRemixData
        }
      });
      this.$ana.track({
        eventCategory:'create',
        eventAction:'pack'
      });
    },
    getTags(template) {
      return (template.tags||'').split(",").map( (t) => {
        return t.trim();
      }).filter( (t) => {
        return t.length > 0
      });
    },
    onSelectImage(asset) {
      console.log('on select image', asset);
      if (asset.__type === 'image') {
        this.image = asset.id;
        console.log('go there');
        this.$router.replace({
          name:'start',
          params:{
            parentId:'root',
            type:'post',
            __autoRemixImage: this.image,
            __autoRemixTitle: ''
          }
        });
        this.$ana.track({
          eventCategory:'create',
          eventAction:'uploadImage'
        });

      } else if (asset.__type === 'animation') {
        this.onSelectAnimation(asset);
        this.$ana.track({
          eventCategory:'create',
          eventAction:'uploadVideo'
        });
      }
    },
    makeImageUrl(template) {
      return this.api.makeImageUrlEditor(template.thumbnailImage);
    },
    onTemplate(template) {
      this.$router.push({
        name:'template',
        params: {
          templateId: template.id
        }
      });
    },
    onChangeDraft({parentId,opId,draft}) {

      console.log('draft', parentId, opId, draft);
      this.$router.push({
        name:'create',
        params:{
          parentId: draft.parentId,
          type: 'post',
          draftId:draft.id
        },
      });
      /*
      const editingGamedata = cloneDeep(JSON.parse(draft.gamedata));
      this.editingGamedata = editingGamedata;

      const gamedata = new Gamedata(editingGamedata);
      this.transformsAndSource = gamedata.getSceneByIndex(0);

      //this.ignoreDrafts = true;

      this.$emit('change-draft', {
        draftId:draft.id,
        parentId,
        opId
      });
      */

    },
    onCreateImage() {
      this.$emit('close');
      this.$router.push({
        name:'start',
        params:{
          parentId: 'root',
          type: 'image',
        },
        query:{
          prompt: undefined
        }
      });
    },

  },
  watch:{
    mode(nv) {
      this.$ana.track({
        eventCategory: 'newmode',
        eventAction:nv
      });
    }
  },
  computed: {
    mode: {
      get() {
        return this.$store.state.selectedCreateMode;
      },
      set(nv) {
        this.$store.commit('setSelectedCreateMode', nv);
      }
    },
    isServer() {
      return !process.browser;
    },
    isBlank: {
      set(nv) {
        this.mode = "blank";
      },
      get() {
        return this.mode === "blank";
      }
    },
    isTemplate: {
      set(nv) {
        this.mode = "template"
      },
      get() {
        return this.mode === 'template';
      }
    },
    isSticker: {
      set(nv) {
        this.mode = "sticker"
      },
      get() {
        return this.mode === 'sticker';
      }
    },
    isVideo: {
      set(nv) {
        this.mode = "video"
      },
      get() {
        return this.mode === 'video';
      }
    },
    isImage: {
      set(nv) {
        this.mode = "image"
      },
      get() {
        return this.mode === 'image';
      }
    },
    isUpload: {
      set(nv) {
        this.mode = "upload"
      },
      get() {
        return this.mode === 'upload';
      }
    },
    isDraft: {
      set(nv) {
        this.mode = 'draft';
      },
      get() {
        return this.mode === 'draft';
      }
    }

  }
}
</script>
<style>
</style>
